export default "/images/vendor/flag-icon-css/flags/4x3/bz.svg?9e8153a1022c0f4282f86a5113951269";